import {IController} from "../../../controllers/IController";
import {InjectionToken} from "@angular/core";
import {ViewSubTitleModel} from "../_models/ViewSubTitleModel";
import {ModelKey} from "../../../models/ModelKey";
import {ControllerEvent} from "../../../event-buses/ControllerEvent";

export const IT_VIEW_SUB_TITLE_CONTROLLER = new InjectionToken<IViewSubTitleController>('IT_VIEW_SUB_TITLE_CONTROLLER');
export const IT_SUB_TITLE = new InjectionToken<string>('IT_SUB_TITLE');

export const MK_VIEW_SUB_TITLE = new ModelKey<ViewSubTitleModel>('MK_VIEW_SUB_TITLE');

export interface IViewSubTitleController extends IController {

  onUpdateSubTitle(controllerEvent: ControllerEvent): void;
}
